export default "__VITE_ASSET__C$wmtJI2__"